export default __webpack_public_path__ + "static/media/cashflow_icon1.4d7e48bb.svg";